module.exports = __webpack_public_path__ + "static/zestawienie_znakow_ue-40e56bca9bae3493b1297d2f6e0fde8c.jpg";